window.$ = window.jQuery = require('jquery');

$(document).ready(function() {

    // fix header
    let headerHeightSet = false;
    let headerHeight;

    $(window).on('scroll', function(){
        let header = $('.header'),
            scroll = $(window).scrollTop();

        if (!headerHeightSet) {
            headerHeight = header.outerHeight(true);
            headerHeightSet = true;
        }
        
        if (scroll >= headerHeight) {
            header.addClass('fixed');
        } else {
            header.removeClass('fixed');
        }
    });

    if($('.checkout-form .wpcf7').length > 0){
        var wpcf7Elm = document.querySelector( '.checkout-form .wpcf7' );
        wpcf7Elm.addEventListener( 'wpcf7mailsent', function( event ) {
            window.location.href = "/thank-you";
        }, false );
    }

    /*blog*/
    $('.js-blogRand').on('click', function () {
        $(location).attr('href', $(this).data('target'))
    })

    $('.js-anch').on('click', function (e) {
        var headerHeight = $('.header').outerHeight();
        var target = $(this).attr('href');
        console.log(headerHeight);
        $('html, body').animate({ scrollTop: ($(target).offset().top) - headerHeight - 20 }, 800);
        return false;
    })
    /*blog*/

    /*Search form*/
    let searchInput = document.querySelector('.js-search__field');
    let searchBtn = document.querySelector('.js-search__btn');
    let resetBtn = document.querySelector('.js-reset__btn');
    if (searchInput) {
        if ($('body').hasClass("search")) {
            $(searchBtn).css({ "display": "none" });
            $(resetBtn).css({ "display": "block" });
        };
        $('#searchform').on('submit', function (event) {
            if (!$(this).find(searchInput).val()) {
                event.preventDefault();
            }
        });
        resetBtn.addEventListener('click', function () {
            $(searchInput).attr('value', '');
            $(resetBtn).css({ "display": "none" });
            $(searchBtn).css({ "display": "block" });
        });
    }
    /*Search form*/

});